import { BotFlow } from '@feedyou/schema'
import { RootState } from '../../../reducers'

export const botFlowSelector = (state: RootState): BotFlow | undefined => state.flow?.present
